import React, { useState } from 'react';
import {
    Box,
    TextField,
    IconButton,
    Typography,
    Chip
} from '@mui/material';
import {
    LocationOn as LocationIcon,
    Edit as EditIcon,
    Clear as ClearIcon
} from '@mui/icons-material';
import MapAddressDialog from './MapAddressDialog';

const PropertyAddressField = ({
    address,
    setAddress,
    addressDisplayName,
    setAddressDisplayName,
    coordinates,
    setCoordinates,
    isPreviewMode,
}) => {
    const [mapDialogOpen, setMapDialogOpen] = useState(false);

    const handleAddressSelect = ({ address: newAddress, displayName, coordinates: newCoordinates }) => {
        setAddress(newAddress);
        if (setAddressDisplayName) {
            setAddressDisplayName(displayName);
        }
        if (setCoordinates) {
            setCoordinates(newCoordinates);
        }
    };

    const handleClearAddress = () => {
        setAddress('');
        if (setAddressDisplayName) {
            setAddressDisplayName('');
        }
        if (setCoordinates) {
            setCoordinates(null);
        }
    };

    const openMapDialog = () => {
        if (!isPreviewMode) {
            setMapDialogOpen(true);
        }
    };

    return (
        <>
            <Box sx={{ position: 'relative' }}>
                <TextField
                    fullWidth
                    label="الموقع"
                    id="address"
                    name="address"
                    value={addressDisplayName || address}
                    variant="outlined"
                    onClick={openMapDialog}
                    InputLabelProps={{
                        shrink: true,
                        style: { fontSize: 16 },
                    }}
                    InputProps={{
                        readOnly: true,
                        style: { cursor: isPreviewMode ? 'default' : 'pointer' },
                        startAdornment: (
                            <LocationIcon
                                color={address ? 'primary' : 'action'}
                                sx={{ mr: 1 }}
                            />
                        ),
                        endAdornment: address && !isPreviewMode ? (
                            <Box sx={{ display: 'flex', gap: 0.5 }}>
                                <IconButton
                                    size="small"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setMapDialogOpen(true);
                                    }}
                                    sx={{ color: 'primary.main' }}
                                >
                                    <EditIcon fontSize="small" />
                                </IconButton>
                                <IconButton
                                    size="small"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleClearAddress();
                                    }}
                                    sx={{ color: 'error.main' }}
                                >
                                    <ClearIcon fontSize="small" />
                                </IconButton>
                            </Box>
                        ) : null
                    }}
                    placeholder={isPreviewMode ? '' : 'انقر لاختيار الموقع على الخريطة'}
                />

                {coordinates && (
                    <Box sx={{ mt: 1, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                        <Chip
                            size="small"
                            label={`خط العرض: ${coordinates.lat.toFixed(6)}`}
                            variant="outlined"
                            color="primary"
                        />
                        <Chip
                            size="small"
                            label={`خط الطول: ${coordinates.lng.toFixed(6)}`}
                            variant="outlined"
                            color="primary"
                        />
                    </Box>
                )}

                {addressDisplayName && addressDisplayName !== address && (
                    <Box sx={{ mt: 1 }}>
                        <Chip
                            size="small"
                            label={`الاسم المخصص: ${addressDisplayName}`}
                            variant="filled"
                            color="secondary"
                            sx={{ fontSize: '0.75rem' }}
                        />
                    </Box>
                )}

                <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                    {isPreviewMode
                        ? (address ? 'موقع العقار على الخريطة' : 'لم يتم تحديد موقع')
                        : 'انقر لفتح الخريطة واختيار موقع العقار بدقة'
                    }
                </Typography>
            </Box>

            <MapAddressDialog
                open={mapDialogOpen}
                onClose={() => setMapDialogOpen(false)}
                onAddressSelect={handleAddressSelect}
                initialAddress={address}
                initialDisplayName={addressDisplayName}
                initialCoordinates={coordinates}
            />
        </>
    );
};

export default PropertyAddressField;
